export default () => ({
    Container: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        flexWrap: 'wrap',

        width: '100%',
        marginTop: 16,

        '& > *': {
            verticalAlign: 'middle',
            alignSelf: 'center'
        },

        '& :only-child': {
            marginLeft: 'auto'
        }
    }
});
